document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.custom-header__mobile-toggle');
  var menu = document.getElementById('CustomHeaderMobileMenu');

  if (!toggle || !menu) return;

  toggle.addEventListener('click', function () {
    var isOpen = menu.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', isOpen);
  });
});